<script setup lang="ts">
import type { PropType } from 'vue';
import GaiaTabBar, { type GaiaTabBarItem } from './GaiaTabBar.vue';
import { gaiaNeutral } from '../themes/tokens';

const props = defineProps({
  items: {
    type: Array as PropType<GaiaTabBarItem[]>,
    required: true,
  },
  active: {
    type: String,
    required: true,
  },
});

const emit = defineEmits<{ select: [key: string] }>();

const cardBorder = gaiaNeutral.borderCard;
const surface = gaiaNeutral.surface;
</script>

<template>
  <!-- A bordered card headed by a `card` GaiaTabBar (Contract View mock:
       Fields · Clauses · Obligations). The body is the active tab's content;
       the card clips it, so rows and footers run edge to edge. -->
  <div class="gaia-tab-card">
    <gaia-tab-bar
      variant="card"
      :items="props.items"
      :active="props.active"
      @select="(key: string) => emit('select', key)"
    >
      <template v-if="$slots.icon" #icon="slotProps">
        <slot name="icon" v-bind="slotProps" />
      </template>
      <template v-if="$slots.actions" #actions>
        <slot name="actions" />
      </template>
    </gaia-tab-bar>
    <slot />
  </div>
</template>

<style scoped>
.gaia-tab-card {
  display: flex;
  flex-direction: column;
  min-width: 0;
  overflow: hidden;
  border: 1px solid v-bind(cardBorder);
  border-radius: 10px;
  background: v-bind(surface);
}
</style>
